import Text from "@/lib/components/ui/text/text";
import { cn } from "@/lib/utils";
import type { ComponentProps, HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";

export default function ThreadsEmpty({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) {
  return <div className={cn("flex flex-col pl-5", className)} {...props} />;
}

export function ThreadsEmptyTitle({
  children,
  className,
  ...props
}: ComponentProps<typeof Text>) {
  const { t } = useTranslation();

  return (
    <Text
      variant="label"
      className={cn("font-semibold text-foreground-pressed", className)}
      {...props}
    >
      {children ?? t("threads_empty_title")}
    </Text>
  );
}

export function ThreadsEmptyDescription({
  children,
  className,
  ...props
}: ComponentProps<typeof Text>) {
  const { t } = useTranslation();

  return (
    <Text variant="label" className={cn("text-foreground-disabled", className)} {...props}>
      {children ?? t("threads_empty_description")}
    </Text>
  );
}
